<template>
  <div data-test-id="permissions-tab-menu">
    <div
      class="bg-responsive-white q-pt-sm sticky-search-container"
    >
      <div class="row q-mb-md no-wrap items-center">
        <div class="col">
          <q-input
            v-model.trim="searchString"
            label="Search"
            dense
            clearable
            debounce="500"
            :disable="permissions.loading"
          />
        </div>
        <div class="col-auto">
          <q-btn
            class="q-pl-sm"
            :label="$q.screen.gt.sm ? 'Select All' : 'All'"
            flat
            dense
            :ripple="false"
            @click="selectAll"
          />
        </div>
      </div>
    </div>
    <permissions-by-category-list
      :permissions="permissions.data"
      :selected-permission-actions="previewedPermissionActions"
      @click-permission="handlePermissionClick"
    />
    <q-inner-loading :showing="permissions.loading" />
  </div>
</template>

<script>
import PermissionsByCategoryList from 'src/modules/admin/role/PermissionsByCategoryList'

export default {
  name: 'PermissionsTabMenu',
  components: {
    PermissionsByCategoryList
  },
  props: {
    previewedPermissionActions: {
      type: Array,
      required: true
    }
  },
  emits: ['unselect-permission-actions', 'select-permission-actions'],
  data () {
    return {
      searchString: ''
    }
  },
  models: {
    permissions: {
      action: true,
      label: true,
      category: true,
      displayOrder: true,
      variables () {
        return {
          searchString: this.searchString
        }
      }
    }
  },
  methods: {
    handlePermissionClick (permission) {
      if (_.includes(this.previewedPermissionActions, permission.action)) {
        this.$emit('unselect-permission-actions', permission.action)
      } else {
        this.$emit('select-permission-actions', permission.action)
      }
    },
    selectAll () {
      this.$emit('select-permission-actions', _.map(this.permissions.data, 'action'))
    }
  }
}
</script>

<style scoped>
.sticky-search-container {
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>
